<template v-if="user">
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Server List
                   </h6>
                   <div class="element-box">
                     <div class="table-responsive">
                       <table class="table table-lightborder">
                         <thead>
                           <tr>
                             <th>#</th>
                             <th>Name</th>
                             <th>Full Address</th>
                             <th>Type</th>
                             <th>Map</th>
                             <th>Players</th>
                             <th>Actions</th>
                           </tr>
                         </thead>
                         <tbody id="serverListTbl">
                           <tr v-for="(server, index) in servers">
                            <td>{{ index }}</td>
                             <td>{{ server.country + ' ' + server.name }}</td>
                             <td>{{ server.full_address }}</td>
                             <td>{{ server.type }}</td>
                             <td>{{ server.map.replace('_zero1', '') }}</td>
                             <td>{{ server.players }}</td>
                             <td><a class="btn btn-primary" v-bind:href="server.steam_url" role="button">Connect</a></td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.authenticated"></app-invitation>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from './partials/Navbar';
import Sidebar from './partials/Sidebar';
import Alert from './partials/Alert';
import DarkColor from './partials/DarkColor';
import RightSidebar from './partials/RightSidebar';
import Invitation from './partials/Invitation';

export default {
  name: 'Servers',
  metaInfo: {
    title: 'servers',
    titleTemplate: 'zero1 by Dreamstart | %s',
    meta: [
      { property: 'og:title', content: 'zero1 by Dreamstart | servers' },
      { property: 'og:site_name', content: 'zero1' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://zero1.gg/servers'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'zero1 by Dreamstart | servers' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      welcomeText: 'Welcome to zero1!',
      servers: [],
    }
  },
  computed: {
    //
  },
  methods: {
    getServers() {
      this.axios.get(`${this.API_URL}/api/v1/servers`).then((res) => {
        res.data.find((s, v) => {
          s.steam_url = `steam://connect/${s.full_address}`;
          this.servers.push(s);
          console.log(this.servers)
        });
      });
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  created() {
    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    this.getServers();
  },
  mounted() {
    //
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
